var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarYearIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar",
    "data-name": "Icon awesome-calendar",
    d: "M.723,11.625H26.277a.727.727,0,0,1,.723.727V28.094A2.9,2.9,0,0,1,24.107,31H2.893A2.9,2.9,0,0,1,0,28.094V12.352A.727.727,0,0,1,.723,11.625ZM27,8.961V6.781a2.9,2.9,0,0,0-2.893-2.906H21.214V.727A.727.727,0,0,0,20.491,0H18.08a.727.727,0,0,0-.723.727V3.875H9.643V.727A.727.727,0,0,0,8.92,0H6.509a.727.727,0,0,0-.723.727V3.875H2.893A2.9,2.9,0,0,0,0,6.781v2.18a.727.727,0,0,0,.723.727H26.277A.727.727,0,0,0,27,8.961Z",
    fill: "#fefefe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarYearIcon);
export default __webpack_public_path__ + "static/media/CalendarYearIcon.2fe4856f349c15d6e7d21b91b7a9c342.svg";
export { ForwardRef as ReactComponent };